import { Routes } from '@angular/router';
import { DashboardV2Component } from './dashboard-v2.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', data: { breadcrumb: 'leftSidebar.dashboard' }, pathMatch: 'full' },
  {
    path: 'home',
    data: { breadcrumb: 'leftSidebar.dashboard' },
    component: DashboardV2Component
  }
];
